import { BattleState, Monster, TurnCommands, TurnResult } from '../types';
import { AIConfig } from './types';
import { CommandWeightMap } from './weightedSelection';
import { selectBestCommandsLv6 } from './lookahead';

/**
 * Lv6 達人 AI のコアロジック（純粋関数）
 *
 * このファイルは Worker 内およびメインスレッド内のインライン実行モードの
 * 両方で使われる。すべての引数はシリアライズ可能であること（関数値は randomFn のみ）。
 *
 * PR2 以降は α-β 多ターン先読み（lookahead.ts）に委譲する本実装。
 * lookAheadDepth=1 で Lv5 とほぼ同等、3 が標準、5 が最強（Worker 必須）。
 *
 * 後続予定:
 * - PR3: 相手モデル化（ベイズ推定）
 * - PR4: リソース最適化
 * - PR5: 混合戦略
 *
 * @param state バトル状態
 * @param playerId AIが操作するプレイヤーID
 * @param monster AIが操作するモンスター
 * @param opponentMonster 相手モンスター
 * @param turnHistory ターン履歴
 * @param aiConfig AI設定（Lv6パラメータ含む）
 * @param randomFn 乱数関数（Worker内では mulberry32(seed) を渡す）
 * @param bossSpecificMods ボス専用コマンドウェイトモディファイア（省略時は無効）
 * @returns 選択された2つのコマンド
 */
export function selectLv6Core(
  state: BattleState,
  playerId: 'player1' | 'player2',
  monster: Monster,
  opponentMonster: Monster,
  turnHistory: TurnResult[],
  aiConfig: AIConfig,
  randomFn: () => number,
  bossSpecificMods?: CommandWeightMap,
): TurnCommands {
  return selectBestCommandsLv6(
    state,
    playerId,
    monster,
    opponentMonster,
    turnHistory,
    aiConfig,
    randomFn,
    bossSpecificMods,
  );
}
